<template>
    <div class="modal fade get_coupon_modal"  :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog" style="width: 870px;">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body">
                    <div class="coupon_modal_hd">领取优惠券</div>
                    <div class="coupon_modal_bd">
                        <ul class="row">
                            <li class="coupon_item col-md-6 col-xs-6" 
                            v-for="(coupon, i) in coupons" :key="('coupon_'+i)"
                            :class="{ reeceived_status: coupon.couponState == 2}"
                            >
                                <div class="coupon_box fix">
                                    <div class="f-fl">
                                        <div class="left_box">
                                            <div class="coupon_title">
                                                {{coupon.promotion}}
                                            </div>
                                            <div class="coupon_date">
                                                有效期：{{coupon.startTime}}-{{coupon.endTime}}
                                            </div>
                                            <div class="coupon_info">
                                                <span role="button" class="couponRule" @click="onCouponRuleClick(coupon.couponRule)">使用规则</span>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="f-fl" @click="onGetCouponClick(coupon)">
                                        <div class="right_box userGetCoupon">
                                            <i class="coupon_status"></i>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "CruiseCouponPopup",
    props: {
        isShow: {
            type: Boolean
        },
        coupons: {
            type: Array
        },
        onCouponRuleClick: {
            type: Function
        },
        setCouponRecieved: {
            type: Function
        },
        showLoginPopup: {
            type: Function
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        },
        async onGetCouponClick(coupon) {
            if (coupon.couponState == 2) {
                return
            }
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                const self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再领取优惠券', {
                    confirmCallBack: () => {
                        self.showLoginPopup(()=> {
                            self.onGetCouponClick(coupon)
                        })
                    }
                })
                return
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.giveUserCoupon({
                id: coupon.id,
                source: 'online'
            })
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
                return
            }
            this.$alert.show("恭喜您成功领取该优惠券！")
            this.setCouponRecieved(coupon.id)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal {
    .modal-dialog {
        top: 20%;
    }
}
.get_coupon_modal .modal-body {
    padding: 25px 20px;
    .coupon_modal_hd {
        font-size: 22px;
        color: #282b2c;
        margin-bottom: 20px;
        .coupon_box {
            color: #051555;
            overflow: hidden;
            margin-bottom: 10px;
        }
    }
}


.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>